//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "qualityOrderDetailBase",
  components: {
  },
  data() {
    return {
      switchChecked1:false,
      switchChecked2:false,
      switchChecked3:false,
      switchChecked4:false,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // toEms(){
    //   this.$router.push({name:'sendOrderEms'})
    // }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/detailBase.vue